<template>
  <div class="stock_add_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <form @submit.prevent="addMapping" style="padding:15px;width:100%;">
          <div class="form-group">
            <label for="ebay_model">Ebay Model *</label>
            <input
              :class="{
                'is-invalid': $v.form.ebay_model.$invalid && submit,
                'is-valid': !$v.form.ebay_model.$invalid && submit
              }"
              type="text"
              ref="ebay_model"
              v-model="form.ebay_model"
              class="form-control"
              id="ebay_model"
              name="ebay_model"
              aria-describedby="model_help"
              placeholder="Model i.e:184234128518"
            />
            <div class="invalid-feedback">Please provide a Model Number</div>
          </div>

          <div class="form-group">
            <label for="stock_model">Stock Model *</label>
            <input
              :class="{
                'is-invalid': $v.form.stock_model.$invalid && submit,
                'is-valid': !$v.form.stock_model.$invalid && submit
              }"
              type="text"
              ref="stock_model"
              v-model="form.stock_model"
              class="form-control"
              id="stock_model"
              name="stock_model"
              aria-describedby="model_help"
              placeholder="Model i.e:IM20-18"
            />
            <div class="invalid-feedback">Please provide a Model Number</div>
          </div>

          <div class="form-group">
            <label for="brand">Brand *</label>
            <select
              :class="{
                'is-invalid': $v.form.brand.$invalid && submit,
                'is-valid': !$v.form.brand.$invalid && submit
              }"
              v-model="form.brand"
              class="form-control"
              id="brand"
              name="brand"
            >
              <option value="">Select</option>
              <option value="SM">SM</option>
              <option value="VM">VM</option>
            </select>
          </div>

          <div class="d-flex flex-row align-items-start">
            <b-btn variant="success" class="mb-2" type="submit">
              Add
            </b-btn>
            <b-btn variant="secondary" class="mb-2 ml-2" :to="'/mappings'">
              Cancel
            </b-btn>
          </div>
          <br />
          <br />
          <br />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "opencart-stock-add",
  components: {},
  data() {
    return {
      form: {
        ebay_model: "",
        stock_model: "",
        brand: ""
      },
      submit: false,
      attributes: false,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Mappings", to: { name: "mappings" } },
        { text: "Add New Mapping", active: true }
      ]
    };
  },
  mounted() {
    this.$refs.model.focus();
  },
  validations: {
    form: {
      ebay_model: {
        required
      },
      stock_model: {
        required
      },
      brand: {
        required
      }
    }
  },
  methods: {
    addMapping() {
      this.submit = true;
      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();
        let formData = {
          ebay_model: this.form.ebay_model,
          stock_model: this.form.stock_model,
          brand: this.form.brand
        };
        this.$http.post(this.APIURL + this.BRAND + "/mappings", formData).then(
          () => {
            this.$swal({
              title: "Success!",
              showConfirmButton: false,
              timer: 1000,
              html:
                "Operation completed successfully, taking you back to mappings list.",
              type: "success",
              onClose: () => {
                loader.hide();
                this.$router.push({ name: "mappings" });
              }
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    }
  }
};
</script>
